var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPendingRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5863_152323)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.0013,
    cy: 20,
    r: 18,
    fill: "#FEF5E7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8667 10H14.4641C13.0063 10 11.7274 10.9847 11.6689 12.4036C11.5954 14.1888 12.851 15.3742 14.1697 16.4871C15.994 18.0266 16.9061 18.7964 17.0018 19.7708C17.0167 19.9233 17.0167 20.0767 17.0018 20.2292C16.9061 21.2036 15.994 21.9734 14.1697 23.5129C12.8147 24.6564 11.5916 25.7195 11.6689 27.5964C11.7274 29.0153 13.0063 30 14.4641 30H24.8667C26.3244 30 27.6034 29.0153 27.6618 27.5964C27.7083 26.4668 27.2897 25.342 26.4005 24.56C25.9951 24.2034 25.5742 23.8615 25.1611 23.5129C23.3368 21.9734 22.4247 21.2036 22.329 20.2292C22.314 20.0767 22.314 19.9233 22.329 19.7708C22.4247 18.7964 23.3368 18.0266 25.1611 16.4871C26.5019 15.3556 27.7382 14.2581 27.6618 12.4036C27.6034 10.9847 26.3244 10 24.8667 10Z",
    stroke: "#F49D1B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6653 29.6381C16.6653 29.1962 16.6653 28.9752 16.7529 28.7821C16.7669 28.7514 16.7823 28.7214 16.7993 28.6923C16.9064 28.509 17.0875 28.3796 17.4497 28.1208C18.4558 27.4021 18.9588 27.0427 19.5305 27.0045C19.6203 26.9985 19.7103 26.9985 19.8001 27.0045C20.3718 27.0427 20.8748 27.4021 21.881 28.1208C22.2432 28.3796 22.4243 28.509 22.5313 28.6923C22.5483 28.7214 22.5638 28.7514 22.5777 28.7821C22.6653 28.9752 22.6653 29.1962 22.6653 29.6381V30H16.6653V29.6381Z",
    stroke: "#F49D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5863_152323",
    x: 0.00128174,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5863_152323"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.615686 0 0 0 0 0.105882 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5863_152323"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5863_152323",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPendingRequest);
export default __webpack_public_path__ + "static/media/icon-pending-request.78cf5082.svg";
export { ForwardRef as ReactComponent };